import { Button, Text, VSpacer } from "@/components/DesignSystem";
import { BookingsList } from '@/components/shared/Booking/BookingsList';
import { ModalBottomSheet } from '@/components/shared/ModalBottomSheet/ModalBottomSheet';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import {
  ApiOrderTransaction,
  ApiSubwalletBalance,
  ApiUser,
} from '@api/interfaces';
import { Divider, Stack, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from 'react-i18next';

interface ReservedPointDetailModalBottomSheetProps {
  balances: ApiSubwalletBalance[],
  bookings: ApiOrderTransaction[],
  brandColor?: string,
  customer: ApiUser,
  linkedAccounts?: ApiUser[],
  onClose: () => void,
}

export const ReservedPointDetailModalBottomSheet = ({
  balances,
  bookings,
  brandColor,
  customer,
  linkedAccounts,
  onClose,
}: ReservedPointDetailModalBottomSheetProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { isMobile } = useMediaQuery();
  const brandColorBg = brandColor ?? theme.palette.primary.main;

  return (
    <ModalBottomSheet
      acceptButton={(props) => (
        <Button
          {...props}
          onClick={() => onClose()}
          sx={{
            backgroundColor: brandColorBg,
            '&:hover': {
              backgroundColor: brandColorBg,
              opacity: 0.9,
            },
          }}
        >
          {t($ => $.common.actions.close)}
        </Button>
      )}
      footer={(
        <Stack px="16px">
          <Button
            color="primary"
            onClick={() => onClose()}
            sx={{
              backgroundColor: brandColorBg,
              '&:hover': {
                backgroundColor: brandColorBg,
                opacity: 0.9,
              },
            }}
            testID="reserved-footer-button"
          >
            {t($ => $.common.actions.close)}
          </Button>
          <VSpacer size="7" />
        </Stack>
      )}
      headerStyle={{ paddingTop: '8px !important', paddingBottom: '0 !important' }}
      hideBottomCloseButton
      hideTopCloseButton
      onClose={onClose}
      open
      showTopButton={false}
      testID="subwallet-balance-modal-bottom-sheet"
      title=""
    >
      {isMobile && (
        <Stack alignItems="center" sx={{ width: '100%' }}>
          <Stack sx={{ width: 36, height: 4, borderRadius: 8, bgcolor: theme.palette.grey[300] }} />
          <VSpacer size="7" />
        </Stack>
      )}
      <Text category="body-medium">
        {t($ => $.wallet.reservedPointDetail.bookingStatus)}
      </Text>
      <VSpacer size="5" />
      <Divider />
      <BookingsList
        balances={balances}
        bookings={bookings}
        brandColor={brandColor}
        customer={customer}
        linkedAccounts={linkedAccounts}
      />
    </ModalBottomSheet>
  );
};
